import { defineContent, type DefinedContent } from '@post-office/define-content';

export const registeredContent: DefinedContent<
	[
		'assignedWorkTitle',
		'activeTeamTitle',
		'assignedWorkBody',
		'activeTeamBody',
		'assignedWorkCta',
		'activeTeamCta',
		'close',
		'whyTitle',
		'whyBody',
	]
> = defineContent({
	default: {
		assignedWorkTitle: {
			id: 'c2j-confluence-side-nav.assigned-work.title',
			defaultMessage: 'You have work waiting in Jira',
			description: 'Title shown to an inactive Jira user with assigned work',
			role: 'title',
		},
		activeTeamTitle: {
			id: 'c2j-confluence-side-nav.active-team.title',
			defaultMessage: 'Your teammates are working in Jira',
			description: 'Title shown when Confluence collaborators are active in Jira',
		},
		assignedWorkBody: {
			id: 'c2j-confluence-side-nav.assigned-work.body',
			defaultMessage: 'Catch up on the Jira work assigned to you.',
			description: 'Description of the assigned Jira work recommendation',
			role: 'description',
		},
		activeTeamBody: {
			id: 'c2j-confluence-side-nav.active-team.body',
			defaultMessage: 'See what your team is planning and tracking in Jira.',
			description: 'Description of the active Jira team recommendation',
		},
		assignedWorkCta: {
			id: 'c2j-confluence-side-nav.assigned-work.cta',
			defaultMessage: 'View your work',
			description: 'CTA for viewing assigned work in Jira',
		},
		activeTeamCta: {
			id: 'c2j-confluence-side-nav.active-team.cta',
			defaultMessage: 'Open Jira project',
			description: 'CTA for opening the Jira project used by teammates',
		},
		close: {
			id: 'c2j-confluence-side-nav.close',
			defaultMessage: 'Dismiss recommendation',
			description: 'Accessible label for dismissing the side navigation recommendation',
		},
		whyTitle: {
			id: 'c2j-confluence-side-nav.why.title',
			defaultMessage: 'Why am I seeing this?',
			description: 'Title of the recommendation explanation',
		},
		whyBody: {
			id: 'c2j-confluence-side-nav.why.body',
			defaultMessage: 'This recommendation is based on Jira work relevant to you and your team.',
			description: 'Explanation of why the Jira recommendation is shown',
		},
	},
});
